import createReducer from 'utils/createReducer';
import {
  GET_USER_MAPPING_SUCCESS,
  SET_USER_MAPPING_PER_PAGE,
  SET_USER_MAPPING_SEARCH_KEYWORD,
  GETTING_USER_MAPPING,
  SET_ACTIVE_USER_MAPPING,
  OPEN_USER_MAPPING_DETAILS,
  CLOSE_USER_MAPPING_DETAILS,
  OPEN_DELETE_USER_MAPPING_MODAL,
  CLOSE_DELETE_USER_MAPPING_MODAL,
  DELETING_USER_MAPPING,
  UPDATING_USER_MAPPING,
  OPEN_CREATE_USER_MAPPING_MODAL,
  CLOSE_CREATE_USER_MAPPING_MODAL,
  CREATING_USER_MAPPING,
  OPEN_CREATE_USER_MAPPING_UPLOAD_MODAL,
  CLOSE_CREATE_USER_MAPPING_UPLOAD_MODAL,
  CREATING_USER_MAPPING_UPLOAD,
  CREATE_USER_MAPPING_UPLOAD_SELECTED_FILE,
} from 'state/actionTypes';
import { combineReducers } from 'redux';

const userMapping = createReducer([], {
  [GET_USER_MAPPING_SUCCESS]: (state, { payload }) => {
    return { ...payload, activeIndex: -1 };
  },
  [SET_ACTIVE_USER_MAPPING]: (state, { payload }) => {
    const { index, userMappingData } = payload;
    const newUserMappingData = { ...userMappingData };
    newUserMappingData.activeIndex = index;
    return newUserMappingData;
  },
});

const gettingUserMapping = createReducer(false, {
  [GETTING_USER_MAPPING]: (state, { payload }) => payload,
});

const userMappingPerPage = createReducer(20, {
  [SET_USER_MAPPING_PER_PAGE]: (state, { payload }) => payload,
});

const userMappingSearchKeyword = createReducer('', {
  [SET_USER_MAPPING_SEARCH_KEYWORD]: (state, { payload }) => payload,
});

const userMappingDetails = createReducer(false, {
  [OPEN_USER_MAPPING_DETAILS]: () => true,
  [CLOSE_USER_MAPPING_DETAILS]: () => false,
});

const deletingUserMapping = createReducer(false, {
  [DELETING_USER_MAPPING]: (state, { payload }) => payload,
});

const deleteUserMappingModal = createReducer(false, {
  [OPEN_DELETE_USER_MAPPING_MODAL]: () => true,
  [CLOSE_DELETE_USER_MAPPING_MODAL]: () => false,
});

const updatingUserMapping = createReducer(false, {
  [UPDATING_USER_MAPPING]: (state, { payload }) => payload,
});

const createUserMappingModal = createReducer(false, {
  [OPEN_CREATE_USER_MAPPING_MODAL]: () => true,
  [CLOSE_CREATE_USER_MAPPING_MODAL]: () => false,
});

const creatingUserMapping = createReducer(false, {
  [CREATING_USER_MAPPING]: (state, { payload }) => payload,
});

const createUserMappingUploadModal = createReducer(false, {
  [OPEN_CREATE_USER_MAPPING_UPLOAD_MODAL]: () => true,
  [CLOSE_CREATE_USER_MAPPING_UPLOAD_MODAL]: () => false,
});

const creatingUserMappingUpload = createReducer(false, {
  [CREATING_USER_MAPPING_UPLOAD]: (state, { payload }) => payload,
});

const createUserMappingUploadSelectedFile = createReducer(null, {
  [CREATE_USER_MAPPING_UPLOAD_SELECTED_FILE]: (state, { payload }) => payload,
});

export default combineReducers({
  userMapping,
  gettingUserMapping,
  userMappingPerPage,
  userMappingSearchKeyword,
  userMappingDetails,
  deletingUserMapping,
  deleteUserMappingModal,
  updatingUserMapping,
  createUserMappingModal,
  creatingUserMapping,
  createUserMappingUploadModal,
  creatingUserMappingUpload,
  createUserMappingUploadSelectedFile,
});
